/* ============================================================
   FESTIVE ANIMATION – PNG Falling Elements
   With Smooth Fade-Out While Falling
   ============================================================ */

(function () {
  try {
    console.log("Festive: script starting...");

    /* ==== IMAGE URLs ==== */
    const SNOW_URL = "https://cdn.shopify.com/s/files/1/0865/2364/2144/files/Untitled_design_3_60ae95cd-50b7-4e6c-8cf9-0306a617fa9e.png?v=1764414877";
    const ORNAMENT_URL = "https://cdn.shopify.com/s/files/1/0865/2364/2144/files/Untitled_design_13.png?v=1764414947";

    /* ==== CONFIG ==== */
    let MAX_ITEMS = 120;
    let SPAWN_INTERVAL = 150;
    const DURATION_MIN = 9000;
    const DURATION_MAX = 16000;
    const TOTAL_SPAWN_TIME = 30000;

    if (window.innerWidth < 480) {
      MAX_ITEMS = 35;
      SPAWN_INTERVAL = 500;
    }

    /* ==== CREATE OVERLAY ==== */
    const overlay = document.createElement("div");
    overlay.className = "festive-overlay";
    overlay.setAttribute("aria-hidden", "true");
    document.body.appendChild(overlay);

    /* ==== IMAGES TO USE ==== */
    const images = [SNOW_URL, ORNAMENT_URL];

    function rand(min, max) {
      return Math.random() * (max - min) + min;
    }

    /* ==== SPAWNER ==== */
    let created = 0;
    const start = Date.now();

    const spawner = setInterval(() => {
      if (created >= MAX_ITEMS) {
        clearInterval(spawner);
        return;
      }

      if (Date.now() - start > TOTAL_SPAWN_TIME) {
        clearInterval(spawner);
        return;
      }

      spawnItem();
      created++;
    }, SPAWN_INTERVAL);

    /* ============================================================
       CREATE ONE FALLING IMAGE (WITH FADE-OUT EFFECT)
       ============================================================ */
    function spawnItem() {
      const item = document.createElement("img");
      item.className = "festive-img";
      item.src = images[Math.floor(Math.random() * images.length)];

      /* Random sizing */
      const size = rand(40, 80);
      item.style.width = size + "px";
      item.style.height = "auto";

      /* Starting state */
      item.style.left = rand(2, 96) + "%";
      item.style.top = "-120px";
      item.style.position = "absolute";
      item.style.opacity = "1";

      const duration = rand(DURATION_MIN, DURATION_MAX);
      const drift = rand(-80, 80);
      const endY = window.innerHeight + 200;

      /* We animate BOTH transform + opacity for full fade-out */
      item.style.transition = `
        transform ${duration}ms linear,
        opacity ${duration}ms linear
      `;

      overlay.appendChild(item);

      /* Start falling + start fading */
      requestAnimationFrame(() => {
        item.style.transform = `translate(${drift}px, ${endY}px)`;
        item.style.opacity = "0"; // fades fully by the time it reaches bottom
      });

      /* Cleanup old items */
      setTimeout(() => {
        if (item && item.parentNode) item.parentNode.removeChild(item);
      }, duration + 500);
    }

    console.log("Festive: overlay active.");

  } catch (err) {
    console.error("Festive: error", err);
  }
})();
